
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { common as ptCommon } from './local/pt/common';
import { common as enCommon } from './local/en/common';
import { common as frCommon } from './local/fr/common';
import { common as esCommon } from './local/es/common';

const resources = {
  pt: { common: ptCommon },
  en: { common: enCommon },
  fr: { common: frCommon },
  es: { common: esCommon },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'pt',
    fallbackLng: 'pt',
    debug: false,
    resources,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  })
  .catch((err) => {
    // Optional: Log initialization errors for debugging purposes
    console.error('i18next initialization error:', err);
  });

export default i18n;
